export const convertZoneArrayToObject = (zones = []) => {
    let zoneObj = {};

    zones.forEach(key => {
        zoneObj = { ...zoneObj, [`${key.id}`]: key.name };
    });

    return zoneObj;
}
